import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_EXCEL_DOWNLOAD_CHALLAN,
  GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING,
  GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT,
  GET_EXCEL_DOWNLOAD_LEAD,
  GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD,
  GET_EXCEL_DOWNLOAD_SALE,
  GET_EXCEL_DOWNLOAD_VEHICLE,
} from "./actionTypes"
import {
  getExcelDownloadSaleSuccess,
  getExcelDownloadSaleFail,
  getExcelDownloadVehicleSuccess,
  getExcelDownloadLeadSuccess,
  getExcelDownloadInvestmentLeadSuccess,
  getExcelDownloadInvestmentLeadFail,
  getExcelDownloadInspectionDocumentSuccess,
  getExcelDownloadChallanSuccess,
  getExcelDownloadChallanFail,
  getExcelDownloadInspectionBookingSuccess,
  getExcelDownloadInspectionBookingFail,
} from "./actions"

import { get } from "helpers/api_helper"

// Helper to check if branch is a valid value
const isValidBranch = (branch) => branch && branch !== "undefined" && branch !== "null" && branch !== ""

// ExcelDownload - This line cannot be edited or removed
function getExcelDownloadSaleAPi({
  page,
  limit,
  searchText,
  clientId,
  vehicleId,
  sortByDate,
  branchId,
}) {
  const branchQuery = isValidBranch(branchId) ? `&branch=${branchId}` : ""

  return get(
    `/sale/download/all/?page=${page ? page : 1}&limit=${limit ? limit : 10
    }&search=${searchText ? searchText : ""}&client=${clientId ? clientId : ""
    }&vehicle=${vehicleId ? vehicleId : ""}&from=${sortByDate?.from ? sortByDate?.from : ""
    }&to=${sortByDate?.to ? sortByDate?.to : ""}${branchQuery}`
  )
}

const getExcelDownloadVehicleApi = ({
  pageVehicle,
  totalItemLimit,
  vehicleSearchText,
  brandId,
  modelId,
  varientId,
  oilTypeValue,
  ownerShipStatusValue,
  sort,
  dateBySort,
  branchId,
}) => {
  const branchQuery = isValidBranch(branchId) ? `&branch=${branchId}` : ""

  return get(
    `/vehicle/download/all/?page=${pageVehicle ? pageVehicle : 1}&limit=${totalItemLimit ? totalItemLimit : 10
    }&search=${vehicleSearchText ? vehicleSearchText : ""}&brand=${brandId ? brandId : ""
    }&model=${modelId ? modelId : ""}&variant=${varientId ? varientId : ""
    }&ownershipStatus=${ownerShipStatusValue ? ownerShipStatusValue : ""
    }&sort=${sort ? sort : ""}&fuelType=${oilTypeValue ? oilTypeValue : ""
    }&from=${dateBySort?.from ? dateBySort?.from : ""}&to=${dateBySort?.to ? dateBySort?.to : ""
    }${branchQuery}`
  )
}

const getExcelDownloadLeadApi = ({
  page,
  sort,
  limit,
  searchText,
  vehicleId,
  typeValue,
  clientId,
  medium,
  sortByDate,
  branchId,
}) => {
  const branchQuery = isValidBranch(branchId) ? `&branch=${branchId}` : ""

  return get(
    `/lead/download/all?sort=${sort ? sort : ""}&leadType=${typeValue ? typeValue : ""
    }&vehicle=${vehicleId ? vehicleId : ""}&page=${page ? page : 1}&limit=${limit ? limit : 10
    }&search=${searchText ? searchText : ""}&client=${clientId && clientId
    }&medium=${medium ? medium : ""}&from=${sortByDate.from}&to=${sortByDate.to
    }${branchQuery}`
  )
}

const getExcelDownloadInvestmentLeadApi = ({
  sort,
  searchText,
  typeValue,
  medium,
  leadCondition,
  singleDate,
  sortByDate,
}) => {
  return get(
    `/investment-lead/download/all?status=${sort === 'all' ? '' : (sort || "")}&type=${typeValue === 'all' ? '' : (typeValue || "")}&medium=${medium === 'all' ? '' : (medium || "")}&leadCondition=${leadCondition === 'all' ? '' : (leadCondition || "")}&search=${searchText || ""}&from=${sortByDate?.from || ""}&to=${sortByDate?.to || ""}&date=${singleDate || ""}`
  )
}

const getExcelDownloadInspectionDocumentApi = ({
  page,
  limit,
  searchText,
  StaffId,
  sortByDate,
}) => {
  return get(
    `/inspection-document/admin/download/all/?page=${page ? page : 1}&limit=${limit ? limit : 10
    }&search=${searchText}&from=${sortByDate?.from || ""}&to=${sortByDate?.to || ""
    }&inspected_by=${StaffId ? StaffId : ""}`
  )
}
const getExcelDownloadChallanApi = ({
  page,
  limit,
  searchText,
  sort,
  sortByDate,
}) => {
  return get(
    `/challan/admin/download/all/?page=${page ? page : 1}&limit=${limit ? limit : 10
    }&search=${searchText}&from=${sortByDate?.from || ""}&to=${sortByDate?.to || ""
    }&status=${sort ? sort : ""}`
  )
}
const getExcelDownloadInspectionBookingApi = ({
  page,
  sort,
  limit,
  searchText,
  sortByDate,
}) => {
  return get(
    `/inspection-booking/admin/download/all/?page=${page ? page : 1}&sort=${sort || ""
    }&limit=${limit ? limit : 10}&search=${searchText}&from=${sortByDate?.from || ""
    }&to=${sortByDate?.to || ""}`
  )
}
function* fetchExcelDownloadSales({ payload }) {
  try {
    const response = yield call(getExcelDownloadSaleAPi, payload)
    yield put(getExcelDownloadSaleSuccess(response))
  } catch (error) {
    yield put(getExcelDownloadSaleFail(error))
  }
}

function* fetchExcelDownloadVehicles({ payload }) {
  try {
    const response = yield call(getExcelDownloadVehicleApi, payload)
    yield put(getExcelDownloadVehicleSuccess(response))
  } catch (error) {
    yield put(getExelDownloadVehicleFail(error))
  }
}

function* fetchExcelDownloadLeads({ payload }) {
  try {
    const response = yield call(getExcelDownloadLeadApi, payload)
    yield put(getExcelDownloadLeadSuccess(response))
  } catch (error) {
    yield put(getExelDownloadLeadFail(error))
  }
}

function* fetchExcelDownloadInvestmentLeads({ payload }) {
  try {
    const response = yield call(getExcelDownloadInvestmentLeadApi, payload)
    yield put(getExcelDownloadInvestmentLeadSuccess(response))
  } catch (error) {
    yield put(getExcelDownloadInvestmentLeadFail(error))
  }
}

function* fetchExcelDownloadInspectionDocument({ payload }) {
  try {
    const response = yield call(getExcelDownloadInspectionDocumentApi, payload)
    yield put(getExcelDownloadInspectionDocumentSuccess(response))
  } catch (error) {
    yield put(getExelDownloadInspectionDocumentFail(error))
  }
}

function* fetchExcelDownloadChallan({ payload }) {
  try {
    const response = yield call(getExcelDownloadChallanApi, payload)
    yield put(getExcelDownloadChallanSuccess(response))
  } catch (error) {
    yield put(getExcelDownloadChallanFail(error))
  }
}

function* fetchExcelDownloadInspectionBooking({ payload }) {
  try {
    const response = yield call(getExcelDownloadInspectionBookingApi, payload)
    yield put(getExcelDownloadInspectionBookingSuccess(response))
  } catch (error) {
    yield put(getExcelDownloadInspectionBookingFail(error))
  }
}
function* excelDownloadSaga() {
  yield takeEvery(GET_EXCEL_DOWNLOAD_SALE, fetchExcelDownloadSales)
  yield takeEvery(GET_EXCEL_DOWNLOAD_VEHICLE, fetchExcelDownloadVehicles)
  yield takeEvery(GET_EXCEL_DOWNLOAD_LEAD, fetchExcelDownloadLeads)
  yield takeEvery(GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD, fetchExcelDownloadInvestmentLeads)
  yield takeEvery(
    GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT,
    fetchExcelDownloadInspectionDocument
  )
  yield takeEvery(GET_EXCEL_DOWNLOAD_CHALLAN, fetchExcelDownloadChallan)
  yield takeEvery(
    GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING,
    fetchExcelDownloadInspectionBooking
  )
}

export default excelDownloadSaga
